import { useEffect } from "react";
import { ChevronRightIcon } from "@heroicons/react/24/outline";
import ConfirmationModalNew from "./ConfirmationModalNew";

const InformationServiceModel = ({
  title,
  open = true,
  content,
  isDisabled = false,
  handleClose = () => {},
  onContinue = () => {}
}) => {

  // to get end service content
  const getContent = () => {
    return (
      <div className="mb-10">
        {content()}
        {
          <>
            <br />
            <button
              className={`float-right m-2 mb-6 h-[38px] w-auto rounded-full bg-REELTeal border-REELTeal hover:bg-teal-200 inline-flex 
            border transition-all duration-300 items-center font-semibold justify-center px-3 py-4 ${isDisabled && "pointer-events-none opacity-40"}`}
              onClick={() => onContinue()}
            >
              <h3 className="text-body-md font-semibold text-white">
                Continue
              </h3>
              <ChevronRightIcon className="w-4 ml-2 h-4 text-white" />
            </button>
          </>
        }
      </div>
    );
  };

  return (
    <ConfirmationModalNew
      open={open}
      title={title}
      content={() => getContent()}
      hideActions={true}
      onCross={() => handleClose()}
    />
  );
};

export default InformationServiceModel;
